import dayjs from 'dayjs';
import { ifClickHandler } from '@lib/events';
import { SonarRecord } from '@ui/records';
import { PeriscopeSfReport, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export type ReportClickHandler = (report: PeriscopeSfReport) => void;

export interface PeriscopeReportProps {
	onReportClick?: ReportClickHandler;
	report: PeriscopeSfReport;
}

export const PeriscopeReport: React.FC<PeriscopeReportProps> = ({ onReportClick, report }) => {
	const handleClick = useMemo(() => ifClickHandler(onReportClick, report), [ report, onReportClick ]);
	const secondaryInfo = report.lastRunDate ? dayjs(report.lastRunDate).format('L') : undefined;

	return (
		<SonarRecord
			name={ report.displayName }
			onClick={ handleClick }
			secondaryInfo={ secondaryInfo }
			sonarObjectId={ report.sonarObjectId }
			sonarObjectType={ SonarObjectType.SalesforceReport } />
	);
};
